export var BLOG_HEADER_TOTAL_RESULTS = 'Wix-SocialBlog-TotalResults';
export var BLOG_HEADER_CURSOR = 'wix-socialblog-cursor';
